import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'

import { Navbar, Dropdown, DropdownButton } from 'react-bootstrap'

import Logo from '../img/logo-ganztags.png'

const CustomNavbar = ({ pageInfo }) => {
  const [activeClass, setActiveClass] = useState('')

  useEffect(() => {
    const path = window.location.pathname
    const arrLink = path.split('/')
    arrLink.splice(0, 1)

    let navL = document.getElementById(arrLink[0])
    if (navL) document.querySelector(`#${navL.id}`).classList.add('active')
  }, [])

  return (
    <Navbar expand="lg" className="p-0 text-center">
      <Navbar.Brand className="p-0">
        <Link to="/">
          <img src={Logo} width="187" height="99" alt="ganztags. Logo" />
        </Link>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <ul className="navbar-nav ml-auto small pl-4" onClick={e => setActiveClass(e.target.id)}>
          <li className="nav-item mr-3 pt-2 pt-md-0">
            <Link
              to="/leistungen"
              className={`nav-link ${
                activeClass === 'leistungen' || activeClass === 'technische-entwicklung' ? 'active' : ''
              }`}
              id="leistungen"
            >
              Leistungen
            </Link>
          </li>
          <li className="nav-item mr-3 pt-2 pt-md-0">
            <Link to="/team/" className={`nav-link ${activeClass === 'team' ? 'active' : ''}`} id="team">
              Über uns
            </Link>
          </li>
          <li className="nav-item mr-3 pt-2 pt-md-0">
            <Link to="/kunden/" className={`nav-link ${activeClass === 'kunden' ? 'active' : ''}`} id="kunden">
              Kunden
            </Link>
          </li>
          <li className="nav-item mr-3 pt-2 pt-md-0">
            <Link to="/jobs/" className={`nav-link ${activeClass === 'jobs' ? 'active' : ''}`} id="jobs">
              Jobs
            </Link>
          </li>
          <li className="nav-item mr-3 mb-5 mb-md-0 pt-2 pt-md-0">
            <Link to="/news/" className={`nav-link ${activeClass === 'news' ? 'active' : ''}`} id="news">
              News
            </Link>
          </li>
        </ul>
        <Link to="/kontakt/" className="btn btn-primary text-uppercase text-white ml-lg-4 mb-4 mb-lg-0">
          Kontakt
        </Link>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default CustomNavbar
